import React from 'react';
import styled from 'styled-components';
import constants from '../../../../../../core/constants';

const ButtonSelect = styled.button.attrs((props: any) => ({
  width: props.width,
  bkgColorEnabled: props.bkgColorEnabled,
  bkgColorHover: props.bkgColorHover,
  bkgColorFocus: props.bkgColorFocus,
  bkgColorPressed: props.bkgColorPressed,
  maxWidth: props.maxWidth,
  minWidth: props.minWidth,
  padding: props.padding
}))`
  width: ${(props) => (props.width ? props.width : 'auto')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'auto')};
  min-width: ${(props) => (props.minWidth ? props.minWidth : '1px')};
  padding: ${(props) => (props.padding ? props.padding : '5px 5px')};
  text-align: left;

  /* MOBILE FIRST */
  /* ENABLE */
  > * {
    overflow: hidden;
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    outline: 0;
  }

  /* HOVER */
  &:hover {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: ${(props) =>
      props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
    outline: 0;
  }

  /* FOCUS */
  &:focus {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: ${(props) =>
      props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
    outline: 0;
  }

  /* ACTIVE */
  > *:active {
    -webkit-transition: background 0ms ease-in-out;
    transition: background 0ms ease-in-out;
    background-color: ${(props) =>
      props.bkgColorPressed ? props.bkgColorPressed : 'none'};
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    /* ENABLE */
    > * {
      overflow: hidden;
      -webkit-transition: background 400ms ease-in-out;
      transition: background 400ms ease-in-out;
      background: ${(props) =>
        props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
      outline: 0;
    }

    /* HOVER */
    &:hover {
      -webkit-transition: background 150ms ease-in-out;
      transition: background 150ms ease-in-out;
      background: ${(props) =>
        props.bkgColorHover ? props.bkgColorHover : 'none'};
    }

    /* FOCUS */
    &:focus {
      -webkit-transition: background 400ms ease-in-out;
      transition: background 400ms ease-in-out;
      background: ${(props) =>
        props.bkgColorFocus ? props.bkgColorFocus : 'none'};
    }

    /* ACTIVE */
    > *:active {
      -webkit-transition: background 0ms ease-in-out;
      transition: background 0ms ease-in-out;
      background-color: ${(props) =>
        props.bkgColorPressed ? props.bkgColorPressed : 'none'};
    }
  }
`;

const ButtonInteractiveSelect = (props: any) => {
  const {
    bkgColorEnabled,
    bkgColorHover,
    bkgColorFocus,
    bkgColorPressed,
    onClick,
    onKeyDown,
    width,
    maxWidth,
    minWidth,
    children,
    padding,
    item,
    currentValue,
    onBlur,
    onFocus
  } = props;
  return (
    <ButtonSelect
      data-testid="btn-interative-select"
      className={`item ${item.value === currentValue?.value ? 'active' : ''}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      width={width}
      bkgColorEnabled={bkgColorEnabled}
      bkgColorHover={bkgColorHover}
      bkgColorFocus={bkgColorFocus}
      bkgColorPressed={bkgColorPressed}
      maxWidth={maxWidth}
      minWidth={minWidth}
      padding={padding}
      onBlur={onBlur}
      onFocus={onFocus}
    >
      {children}
    </ButtonSelect>
  );
};

export default ButtonInteractiveSelect;
